export function ExclamationIcon({
  className = 'text-fx-rose',
}: {
  className?: string;
}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.001 6.66663V7.99996M8.001 10.6666H8.00767M3.3822 13.3333H12.6198C13.6462 13.3333 14.2877 12.2222 13.7745 11.3333L9.1557 3.33329C8.6425 2.4444 7.3595 2.4444 6.8463 3.33329L2.2275 11.3333C1.7143 12.2222 2.3558 13.3333 3.3822 13.3333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
